<template>
  <div class="zt-accordion w-full">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ztAccordion",
  provide() {
    return {
      wrapperPanels: this,
    }
  },
  data() {
    return {
      children: []
    }
  },
  created() {
    this.$on('create-children', (newChild) => {
      this.children.push(newChild)
    })
  }
}
</script>

<style scoped>

</style>